import { createContext, useContext } from 'react';

export const AddonEditorContext = createContext();

export function useEditorContext() {
  return useContext(AddonEditorContext);
}
